import request from "../plugins/request";

/**
 * 空气质量查询
 * @tutorial http://yapi.guanyingis.com/project/209/interface/api/5108
 */
export const getAirData = (params) => {
  params.city = '廊坊'
  return request({
    baseURL: "https://ai.guanyingis.com",
    url: "/api/aqi/app/index",
    method: "get",
    loading: false,
    params,
  });
};
